import { makeStyles } from '@material-ui/core';
import React from 'react';

import { Colors } from 'src/common/ui/base';
import { ButtonToDropdownMenu } from 'src/common/ui/components';
import { formatTimestampDifference } from 'src/components/pages/pageElements/videoConference/domain/formatTimestampDifference';

type AutoCancelCountdownProps = {
  currentTime: number;
  showAutoCancelOverride: boolean;
  autoCancelAt?: number;
  onOverride: () => Promise<void>;
};

export const AutoCancelCountdown = ({
  currentTime,
  autoCancelAt,
  showAutoCancelOverride,
  onOverride,
}: AutoCancelCountdownProps) => {
  const classes = useStyles();

  return (
    <div className={classes.countdownContainer}>
      {showAutoCancelOverride && (
        <div className={classes.autoCancelActiveContainer}>
          <p className={classes.countdownText}>
            Visit will be auto-canceled in:{' '}
            <b>{formatTimestampDifference(currentTime, autoCancelAt)}</b>
          </p>
          <ButtonToDropdownMenu
            menuItems={[{ label: 'Do not auto-cancel visit', onClick: onOverride }]}
          />
        </div>
      )}
      {!showAutoCancelOverride && (
        <div>
          <p className={classes.countdownText}>
            Visit will be auto-canceled in: <b>--:--</b>
          </p>
          <p className={classes.autoCancelOffText}>Auto-cancel turned off for this visit</p>
        </div>
      )}
    </div>
  );
};

const useStyles = makeStyles({
  countdownContainer: {
    fontSize: '12px',
    fontWeight: 600,
    margin: 0,
    color: Colors.CoolGray7,
  },
  autoCancelActiveContainer: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  },
  countdownText: {
    margin: 0,
  },
  autoCancelOffText: {
    margin: 0,
    fontStyle: 'italic',
  },
});
